<template>
  <v-table class="mt-10">
    <thead>
    <tr class="font-weight-bold">
      <th class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">
        You Are Paying For
      </th>
      <th class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">
        Amount, AED
      </th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td class="bottom-grey" v-if="payment">{{payment.provider}}</td>
      <td class="bottom-grey" colspan="2" v-if="payment">{{payment.amount}}</td>
    </tr>
    </tbody>
    <tbody>
    <tr>
      <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Receiving To Account:</td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
    </tr>
    <tr>
      <td class="text-left bottom-grey" colspan="3" v-if="payment">{{ payment.wallet }}</td>
    </tr>
    </tbody>
    <tbody>
    <tr>
      <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Amount to account, USDT:</td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
    </tr>
    <tr>
      <td class="text-left bottom-grey" colspan="3" v-if="payment">{{ payment.amount_to }}</td>
    </tr>
    </tbody>
    <tbody>
    <tr>
      <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Date Expired:</td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
    </tr>
    <tr>
      <td class="text-left bottom-grey" colspan="3" v-if="payment">{{ payment.expired_at }}</td>
    </tr>
    </tbody>
  </v-table>

  <v-row class="mt-8" no-gutters justify="center">
    <v-col
      cols="12"
      align="center"
    >
      <v-btn
        color="info"
        class="btn-fixed"
        @click="setPaid()"
      >
        i SENDED MONEY
      </v-btn>
    </v-col>
  </v-row>
  <v-row class="mt-5 texts-pay">
    <v-col>
      <div class="text-center">
        <div class="text-left">Payment Instructions</div>
        <div class="text-left">Please follow these instructions carefully to ensure your payment is processed successfully.</div>
        <br/>
        <div class="text-left">Payment Amount:</div>
        <div class="text-left">- You must pay the exact amount of <div v-if="payment">{{ payment.amount_to }}</div>.</div>
        <div class="text-left">- Do not alter this amount. Any payment for a different sum may be rejected or cause significant delays.</div>
        <br/>
        <div class="text-left">Payment Deadline:</div>
        <div class="text-left">- The payment must be completed within 24 hours from the time you receive this instruction.</div>
        <div class="text-left">- Payments made after this 24-hour window may not be accepted.</div>
        <br/>
        <div class="text-left">Important Notes:</div>
        <div class="text-left">- Failure to adhere to these instructions may result in a failed transaction. Thank you for your prompt cooperation.</div>
      </div>
    </v-col>
  </v-row>
</template>

<script> /* eslint-disable */
import {inject, onMounted, ref} from 'vue'
import router from '@/utils/router'
import axios from '@/utils/axios-http'
import {useRoute} from "vue-router";

export default {
  data() {
    return {
      enabled: true,
    };
  },
  name: 'PayView',
  setup (props, context) {
    const { setStorage } = inject('storage')
    const { setToRoute } = inject('history')

    const route = useRoute()
    const payment = ref()

    const getPayment = () => {
      axios.get(`crypto/payment/?s=${route.query.s}`)
        .then(response => {
          if (response.data && response.data.payment) {
            console.log(response.data.payment)
            payment.value = response.data.payment
            setStorage('overlay', false)
          } else {
            setStorage('overlay', false)
            router.push({ name: '404' })
          }
        }).catch(function () {
          setStorage('overlay', false)
          router.push({ name: '404' })
        })
    }

    const setPaid = () => {
      const data = {
        payment_id: payment.value.payment_id
      }
      setStorage('overlay', true)
      axios.post(`crypto/payment/paid`, data)
        .then(response => {
          setStorage('overlay', false)
          router.push({ name: 'home' })
        })
    }

    onMounted(() => {
        getPayment()
    })
    return {
      payment,
      setPaid,
      setToRoute
    }
  }
}
</script>
<style>
main {
  padding: 64px 0px 0px;
}
.bottom-grey {
  border-bottom: 1px solid rgb(225, 225, 225);
}
.texts-pay a {
  text-decoration: none;
  color: #1940e1;
}
.texts-pay {
  font-size: 11px;
}
</style>
